import { Box, TextField, Typography } from "@mui/material";
import styles from './InputTextField.module.scss';
import { getInputLabelProps, getInputProps } from "../../../../common/Utils";
import { InputFieldProps } from "../../../../common/Interfaces";

export default function InputPasswordTextField ({id, 
                                                 label,
                                                 value, 
                                                 handleValueChange, 
                                                 errorMessage, 
                                                 width, 
                                                 onKeyPress, 
                                                 isReadOnly}:InputFieldProps){

    return (<Box className={styles.hotizontalContainer}>
        <Box sx={{width: width ?? "100%"}}>
        <TextField
            type="password"
            sx={{width: width ?? "100%"}}
            id={id}
            name={id}
            size="small"
            inputProps={{
                ...getInputProps(),
                readOnly: isReadOnly,
            }}
            InputLabelProps={getInputLabelProps()}
            label={label}
            variant="outlined"
            value={value}
            onChange={handleValueChange}
            error={!!errorMessage}
            onKeyUp={onKeyPress}
        />
        {errorMessage && (
            <Typography className={styles.errorText}>
                {errorMessage}
            </Typography>
        )}
        </Box>
    </Box>);
}